export const SET_ITENS = 'setUser';
export const LOADING = 'setLoading';
export const LOADING_ADD = 'setLoadingAdd';
